import { useState } from "react";

import { CButton, CNumberInput } from "src/common/components/controls";

import { initRow } from ".";

export const AddMoreRow = ({ append }) => {
  //#region Data
  const [count, setCount] = useState(2);
  //#endregion

  //#region Event
  const onAdd = () => {
    const validCount = Math.floor(count) || 0;
    if (validCount > 0) {
      append(Array(validCount).fill(initRow));
    }
  };
  //#endregion

  //#region Render
  return (
    <div className="flex items-center !gap-3">
      <CButton onClick={onAdd}>Thêm nhiều</CButton>
      <CNumberInput value={count} onChange={(newValue) => setCount(newValue)} />
    </div>
  );

  //#endregion
};
